import gtagEventEmitter from "helpers/gtagEventEmitter";
import { MAP_TYPES } from "../../constant";
import styles from "./toggleTab.module.scss";
import { EVENT_LABEL } from "constants/index";
import useTranslationHook from "hooks/useTranslationHook";

type ToggleTabProps = {
  mapType: keyof typeof MAP_TYPES;
  setMapType: any;
};

const ToggleTab = ({ mapType, setMapType }: ToggleTabProps) => {
  const handleOnClick = (type: string) => {
    setMapType(type);
    gtagEventEmitter({
      action: EVENT_LABEL.MAP_VIEW_TOGGLE_CLICKED,
      view_type: type,
    });
  };
  const { t } = useTranslationHook();
  return (
    <div className={styles.mapTypeButtonGroup}>
      <button
        type="button"
        className={
          mapType === MAP_TYPES.ROAD_VIEW ? styles.mapTypeButtonActive : styles.mapTypeButton
        }
        onClick={() => handleOnClick(MAP_TYPES.ROAD_VIEW)}
      >
        {t("propertypage.components.mapsectionv2.mapviewbutton")}
      </button>
      <button
        type="button"
        className={
          mapType === MAP_TYPES.STREET_VIEW ? styles.mapTypeButtonActive : styles.mapTypeButton
        }
        onClick={() => handleOnClick(MAP_TYPES.STREET_VIEW)}
      >
        {t("propertypage.components.mapsectionv2.streetviewbutton")}
      </button>
    </div>
  );
};

export default ToggleTab;
